import { useState, useEffect, useMemo, useCallback } from "react";
import axios from "axios";
//import api from "../lservices/Api";
import AlertModal from "../lservices/AlertModal";
import API_URL from "../config";
import {
  Building2,
  LayoutDashboard,
  Home,
  Users,
  Plus,
  Pencil,
  Trash2,
  Check,
  X,
  ChevronLeft,
  ChevronRight,
  Phone,
  AlertTriangle,
  Loader2,
  RotateCcw,
  Receipt,
  DoorOpen,
  Upload,
  ImagePlus,
  Search,
} from "lucide-react";

const STORAGE_KEY = "immeuble-loyers-data";
const DUE_DAY = 5;
const MONTHS_FR = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre",
];

function monthKey(year, monthIndex) {
  return `${year}-${String(monthIndex + 1).padStart(2, "0")}`;
}

function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

function formatFCFA(n) {
  return (
    new Intl.NumberFormat("fr-FR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(Number(n) || 0) + " FCFA"
  );
}

function uid() {
  return Math.random().toString(36).slice(2, 10);
}

function seedData() {
  return {
    building: {
      name: "GESTION DES LOYERS",
      address: ".............",
    },
    units: [
      {
        id: uid(),
        number: "A1",
        floor: "RDC",
        tenantName: "Marie Ngo Bell",
        tenantPhone: "6 90 12 34 56",
        rent: 85000,
        active: false,
      },
      {
        id: uid(),
        number: "A2",
        floor: "RDC",
        tenantName: "Paul Eto'o Manga",
        tenantPhone: "6 77 45 12 90",
        rent: 85000,
        active: false,
      },
      {
        id: uid(),
        number: "B1",
        floor: "1er étage",
        tenantName: "Sylvie Abena",
        tenantPhone: "6 55 33 21 08",
        rent: 120000,
        active: false,
      },
      {
        id: uid(),
        number: "B2",
        floor: "1er étage",
        tenantName: "",
        tenantPhone: "",
        rent: 120000,
        active: false,
      },
    ],
    payments: {},
  };
}

function Stamp({ label, tone }) {
  const color =
    tone === "paid"
      ? "var(--rl-stamp-green)"
      : tone === "late"
        ? "var(--rl-stamp-red)"
        : "var(--rl-muted)";
  return (
    <span className="rl-stamp" style={{ color }}>
      {label}
    </span>
  );
}

function EmptyNote({ children }) {
  return <div className="rl-empty">{children}</div>;
}

function UnitForm({ initial, onCancel, chargerAppartements }) {
  const [form, setForm] = useState(
    initial || {
      number: "",
      floor: "",
      tenantName: "",
      tenantPhone: "",
      tenantCaution: "",
      rent: "",
      active: true,
    },
  );
  const [nmlocataire, setNmlocataire] = useState("");
  const [mtloyers, setMtloyers] = useState(0);
  const [mtcaution, setCaution] = useState(0);
  const [telnumber, setTelnumber] = useState("");
  const [etages, setEtages] = useState([]);
  const [error, setError] = useState("");
  const [loyers, setLoyers] = useState([]);
  function update(field, value) {
    setForm((f) => ({ ...f, [field]: value }));
  }

  async function submit(e) {
    e.preventDefault();

    setError("");

    if (!form.idloyer) {
      setError("Sélectionnez un loyer.");
      return;
    }

    if (nmlocataire.trim() === "") {
      setError("Nom du locataire obligatoire.");
      return;
    }

    try {
      const payload = {
        mtmensuel: mtloyers,
        nmlocataire,
        phonelocataire: telnumber,
        cautionlocation: mtcaution,
      };

      const res = initial
        ? // Modification d'une location existante : on corrige la ligne en base
          await axios.put(
            `${API_URL}/modifier_location/${form.idloyer}/`,
            payload,
          )
        : // Nouvelle location
          await axios.post(`${API_URL}/ajouter_location/`, {
            idloyer: form.idloyer,
            ...payload,
            debutlocation: new Date().toISOString().split("T")[0],
            finlocation: null,
            statutlocation: 1,
          });

      console.log(res.data);

      // Recharger les appartements
      if (chargerAppartements) {
        chargerAppartements();
      }

      // Réinitialiser le formulaire
      setForm({
        number: "",
        floor: "",
        tenantName: "",
        tenantPhone: "",
        tenantCaution: "",
        rent: "",
        active: true,
        idloyer: "",
      });

      setMtloyers(0);
      setCaution(0);
      setNmlocataire("");
      setTelnumber("");

      onCancel();
    } catch (err) {
      console.error(err);

      if (err.response?.data?.error) {
        setError(err.response.data.error);
      } else {
        setError(
          initial
            ? "Erreur lors de la modification."
            : "Erreur lors de l'enregistrement.",
        );
      }
    }
  }
  /*useEffect(() => {
    axios
      .get(`${API_URL}/liste_etages/`)
      .then((res) => setEtages(res.data))
      .catch((err) => console.error(err));
  }, []);*/

  useEffect(() => {
    if (initial) {
      // Les infos du locataire sont imbriquées dans initial.location
      const loc = initial.location || {};

      // Charger les champs du formulaire
      setForm((f) => ({
        ...f,
        idloyer: initial.idloyer || "",
        number: initial.codeloyer || "",
        floor: initial.netage || "",
        rent: initial.prixloyer || "",
        tenantName: loc.nmlocataire || "",
        tenantPhone: loc.phonelocataire || "",
        tenantCaution: loc.cautionlocation || "",
      }));

      // Charger les champs séparés
      setNmlocataire(loc.nmlocataire || "");
      setTelnumber(loc.phonelocataire || "");
      setMtloyers(loc.mtmensuel || initial.prixloyer || 0);
      setCaution(loc.cautionlocation || 0);
    }
  }, [initial]);
  useEffect(() => {
    axios
      .get(`${API_URL}/loyers_libres/`)
      .then((res) => setLoyers(res.data))
      .catch((err) => console.error(err));
  }, []);

  // En édition, le loyer concerné est occupé donc absent de "loyers libres" :
  // on l'ajoute manuellement à la liste pour qu'il s'affiche dans le select.
  const displayLoyers = useMemo(() => {
    if (!initial) return loyers;

    const dejaPresent = loyers.some((l) => l.idloyer === initial.idloyer);
    if (dejaPresent) return loyers;

    const loc = initial.location || {};
    return [
      {
        idloyer: initial.idloyer,
        codeloyer: initial.codeloyer,
        netage: initial.netage,
        prixloyer: initial.prixloyer,
        occupe: true,
        nmlocataire: loc.nmlocataire,
        phonelocataire: loc.phonelocataire,
        cautionlocation: loc.cautionlocation,
      },
      ...loyers,
    ];
  }, [loyers, initial]);

  return (
    <div className="rl-modal-backdrop" onClick={onCancel}>
      <form
        className="rl-modal"
        onClick={(e) => e.stopPropagation()}
        onSubmit={submit}
      >
        <h3 className="rl-modal-title">
          {initial ? "Modifier les informations du bail" : "Nouvelle location"}
        </h3>

        <div className="rl-field-row">
          <label className="rl-field" style={{ flex: 2 }}>
            <span>Étage</span>

            <select
              className="rl-select"
              value={form.idloyer || ""}
              disabled={!!initial}
              onChange={(e) => {
                const loyer = displayLoyers.find(
                  (l) => l.idloyer === Number(e.target.value),
                );

                if (!loyer) return;

                update("idloyer", loyer.idloyer);
                update("number", loyer.codeloyer);
                update("floor", loyer.netage);
                update("rent", loyer.prixloyer);
                setMtloyers(loyer.prixloyer);

                if (loyer.occupe) {
                  update("tenantName", loyer.nmlocataire);
                  update("tenantCaution", loyer.cautionlocation);
                  update("tenantPhone", loyer.phonelocataire);
                }
              }}
            >
              <option value="">Sélectionner un loyer</option>

              {displayLoyers.map((loyer) => (
                <option key={loyer.idloyer} value={loyer.idloyer}>
                  {loyer.codeloyer} - {loyer.netage} (
                  {formatFCFA(loyer.prixloyer)})
                </option>
              ))}
            </select>
          </label>

          <label className="rl-field" style={{ flex: 1 }}>
            <span>Libellé loyer</span>
            <input
              value={form.number}
              readOnly
              onChange={(e) => update("number", e.target.value)}
              placeholder=""
            />
          </label>
        </div>
        <div className="rl-field-row">
          <label className="rl-field">
            <span>Loyer mensuel initial (FCFA)</span>
            <input
              type="text"
              value={form.rent ? formatFCFA(form.rent) : ""}
              readOnly
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // conserve uniquement les chiffres
                update("rent", value);
              }}
              placeholder="0 FCFA"
            />
          </label>
          <label className="rl-field">
            <span>
              Loyer mensuel:{" "}
              {form.rent && (
                <small style={{ color: "red", fontWeight: "bold" }}>
                  {formatFCFA(mtloyers)}
                </small>
              )}
            </span>
            <input
              type="number"
              value={mtloyers}
              onChange={(e) => setMtloyers(e.target.value)}
              placeholder=""
            />
          </label>
        </div>
        <div className="rl-field-row">
          <label className="rl-field">
            <span>
              Montant de la caution:{" "}
              <small style={{ color: "red", fontWeight: "bold" }}>
                {formatFCFA(mtcaution)}
              </small>
            </span>

            <input
              value={mtcaution}
              onChange={(e) => setCaution(e.target.value)}
              placeholder=""
            />
          </label>
        </div>

        <>
          <label className="rl-field">
            <span>Nom du locataire</span>
            <input
              value={nmlocataire}
              onChange={(e) => setNmlocataire(e.target.value)}
              placeholder={form.tenantName}
            />
          </label>
          <label className="rl-field">
            <span>Téléphone</span>
            <input
              value={telnumber}
              onChange={(e) => setTelnumber(e.target.value)}
              placeholder=""
            />
          </label>
        </>

        {error && (
          <div className="rl-error">
            <AlertTriangle size={14} /> {error}
          </div>
        )}

        <div className="rl-modal-actions">
          <button
            type="button"
            className="rl-btn rl-btn-ghost"
            onClick={onCancel}
          >
            Annuler
          </button>
          <button type="submit" className="rl-btn rl-btn-primary">
            {initial ? "Modifier" : "Enregistrer"}
          </button>
        </div>
      </form>
    </div>
  );
}
function ConfirmDialog({ idloyer, text, onCancel, onConfirm }) {
  return (
    <div className="rl-modal-backdrop" onClick={onCancel}>
      <div
        className="rl-modal rl-modal-small"
        onClick={(e) => e.stopPropagation()}
      >
        <p className="rl-confirm-text">{text}</p>
        <div className="rl-modal-actions">
          <button className="rl-btn rl-btn-ghost" onClick={onCancel}>
            Annuler
          </button>
          <button
            className="rl-btn rl-btn-danger"
            onClick={() => onConfirm(idloyer)}
          >
            Confirmer
          </button>
        </div>
      </div>
    </div>
  );
}

// Le tableau de bord s'appuie désormais sur les vraies données du backend :
//  - "units"    vient de /appartlist/ (Tblloyers, avec la location active
//                imbriquée dans unit.location grâce à la relation FK
//                Tbllocation.idloyer -> Tblloyers.idloyer)
//  - "payments" vient de /etat_paiements_locations/ (agrégat de Tblpaiement
//                par idlocation puis par mois "YYYY-MM", cf. la relation
//                Tbllocation.idlocation -> Tblpaiement.idlocation)
// On applique les mêmes règles de lecture que dans PaymentsView pour rester
// cohérent avec le reste de l'écran, quelle que soit la forme exacte
// renvoyée par l'API pour chaque lot.
function getIdLocation(u) {
  return u.idlocation || u.location?.idlocation || u.id;
}

function getUnitRent(u, p) {
  return Number(
    p?.rent ??
      u.location?.mtmensuel ??
      u.mtmensuel ??
      u.rent ??
      u.prixloyer ??
      0,
  );
}

function getTenantName(u, p) {
  return (
    p?.tenantName ||
    u.location?.nmlocataire ||
    u.nmlocataire ||
    u.tenantName ||
    "—"
  );
}

function getTenantPhone(u, p) {
  return (
    p?.phone ||
    u.location?.phonelocataire ||
    u.phonelocataire ||
    u.tenantPhone ||
    ""
  );
}

function getUnitCode(u, p) {
  return p?.number || u.codeloyer || u.number || "—";
}

function Dashboard({
  units,
  payments,
  period,
  onChangePeriod,
  loadingPayments,
}) {
  const activeUnits = units.filter(
    (u) => u.occupe === true || u.active === true,
  );
  const key = monthKey(period.year, period.month);

  const expected = activeUnits.reduce((sum, u) => {
    const p = payments[getIdLocation(u)]?.[key];
    return sum + getUnitRent(u, p);
  }, 0);

  const collected = activeUnits.reduce((sum, u) => {
    const p = payments[getIdLocation(u)]?.[key];
    if (p?.statut === "PAYE") return sum + getUnitRent(u, p);
    if (p?.statut === "PARTIEL") return sum + Number(p.montantPaye || 0);
    return sum;
  }, 0);

  const pending = Math.max(expected - collected, 0);
  const occupancy = units.length
    ? Math.round((activeUnits.length / units.length) * 100)
    : 0;

  const now = new Date();
  const isCurrentRealMonth =
    now.getFullYear() === period.year && now.getMonth() === period.month;
  const pastDueDay = isCurrentRealMonth ? now.getDate() > DUE_DAY : true;

  const overdue = activeUnits.filter((u) => {
    const p = payments[getIdLocation(u)]?.[key];
    const paid = p?.statut === "PAYE";
    return !paid && pastDueDay;
  });

  const history = useMemo(() => {
    const items = [];
    for (let i = 5; i >= 0; i--) {
      const d = new Date(period.year, period.month - i, 1);
      const y = d.getFullYear();
      const m = d.getMonth();
      const k = monthKey(y, m);

      let exp = 0;
      let col = 0;
      activeUnits.forEach((u) => {
        const p = payments[getIdLocation(u)]?.[k];
        const rent = getUnitRent(u, p);
        exp += rent;
        if (p?.statut === "PAYE") col += rent;
        else if (p?.statut === "PARTIEL") col += Number(p.montantPaye || 0);
      });

      items.push({
        label: `${MONTHS_FR[m].slice(0, 3)}`,
        rate: exp ? Math.round((col / exp) * 100) : 0,
      });
    }
    return items;
  }, [units, payments, period]);

  return (
    <div>
      <div className="rl-panel-header" style={{ marginBottom: 16 }}>
        <h3 className="rl-panel-title" style={{ margin: 0 }}>
          Tableau de bord
        </h3>

        <div className="rl-period-switch">
          <button
            type="button"
            className="rl-icon-btn"
            onClick={() => onChangePeriod(-1)}
            disabled={loadingPayments}
            title="Mois précédent"
          >
            <ChevronLeft size={16} />
          </button>

          <span className="rl-period-label">
            {MONTHS_FR[period.month]} {period.year}
          </span>

          <button
            type="button"
            className="rl-icon-btn"
            onClick={() => onChangePeriod(1)}
            disabled={loadingPayments}
            title="Mois suivant"
          >
            <ChevronRight size={16} />
          </button>
        </div>
      </div>

      <div className="rl-cards-grid">
        <div className="rl-card">
          <span className="rl-card-label">Loyers attendus</span>
          <span className="rl-card-value">{formatFCFA(expected)}</span>
          <span className="rl-card-sub">
            {MONTHS_FR[period.month]} {period.year}
          </span>
        </div>
        <div className="rl-card">
          <span className="rl-card-label">Loyers encaissés</span>
          <span
            className="rl-card-value"
            style={{ color: "var(--rl-stamp-green)" }}
          >
            {formatFCFA(collected)}
          </span>
          <span className="rl-card-sub">
            {expected ? Math.round((collected / expected) * 100) : 0}% du mois
          </span>
        </div>
        <div className="rl-card">
          <span className="rl-card-label">Impayés</span>
          <span
            className="rl-card-value"
            style={{
              color: pending > 0 ? "var(--rl-stamp-red)" : "var(--rl-ink)",
            }}
          >
            {formatFCFA(pending)}
          </span>
          <span className="rl-card-sub">
            {overdue.length} locataire{overdue.length > 1 ? "s" : ""} en retard
          </span>
        </div>
        <div className="rl-card">
          <span className="rl-card-label">Taux d'occupation</span>
          <span className="rl-card-value">{occupancy}%</span>
          <span className="rl-card-sub">
            {activeUnits.length} / {units.length} lots occupés
          </span>
        </div>
      </div>

      <div className="rl-panel">
        <h3 className="rl-panel-title">Locataires en retard</h3>
        {overdue.length === 0 ? (
          <EmptyNote>
            Tous les loyers du mois sont à jour. Le registre est propre.
          </EmptyNote>
        ) : (
          <ul className="rl-overdue-list">
            {overdue.map((u) => {
              const idlocation = getIdLocation(u);
              const p = payments[idlocation]?.[key];
              const tenantName = getTenantName(u, p);
              const tenantPhone = getTenantPhone(u, p);
              const rent = getUnitRent(u, p);
              const reste = Number(
                p?.reste ?? Math.max(rent - Number(p?.montantPaye || 0), 0),
              );

              return (
                <li key={idlocation} className="rl-overdue-item">
                  <div>
                    <strong>{tenantName}</strong>
                    <span className="rl-muted"> — Lot {getUnitCode(u, p)}</span>
                  </div>
                  <div className="rl-overdue-right">
                    <span>{formatFCFA(reste || rent)}</span>
                    {tenantPhone && (
                      <a
                        className="rl-phone-link"
                        href={`tel:${tenantPhone.replace(/\s/g, "")}`}
                      >
                        <Phone size={13} /> {tenantPhone}
                      </a>
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}

function ApartmentsView({ units, onAdd, onEdit, onDelete }) {
  const [search, setSearch] = useState("");

  const filteredUnits = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return units;
    return units.filter((unit) => {
      const tenantName = unit.location?.nmlocataire || "";
      const tenantPhone = unit.location?.phonelocataire || "";
      const haystack = [tenantName, tenantPhone, unit.codeloyer, unit.netage]
        .join(" ")
        .toLowerCase();
      return haystack.includes(q);
    });
  }, [units, search]);

  return (
    <div className="rl-panel">
      <div className="rl-panel-header">
        <h3 className="rl-panel-title">Plan d'occupation de l'immeuble</h3>
        <button className="rl-btn rl-btn-primary rl-btn-sm" onClick={onAdd}>
          <Plus size={15} /> Nouvelle location
        </button>
      </div>

      <div
        className="rl-search-bar"
        style={{ position: "relative", margin: "0 0 14px" }}
      >
        <Search
          size={15}
          style={{
            position: "absolute",
            left: 10,
            top: "50%",
            transform: "translateY(-50%)",
            opacity: 0.5,
          }}
        />
        <input
          type="text"
          className="rl-input"
          placeholder="Rechercher un locataire (nom, téléphone, lot, étage)..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            width: "100%",
            padding: "8px 10px 8px 32px",
            boxSizing: "border-box",
          }}
        />
        {search && (
          <button
            type="button"
            onClick={() => setSearch("")}
            title="Effacer"
            className="rl-icon-btn"
            style={{
              position: "absolute",
              right: 6,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            <X size={14} />
          </button>
        )}
      </div>

      {filteredUnits.length === 0 ? (
        <EmptyNote>Aucun locataire ne correspond à « {search} ».</EmptyNote>
      ) : (
        <div className="rl-table-wrap">
          <table className="rl-table">
            <thead>
              <tr>
                <th>Libelé</th>
                <th>Étage</th>
                <th>Locataire</th>
                <th>Téléphone</th>
                <th>Loyer</th>
                <th>Statut</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filteredUnits.map((unit) => (
                <tr key={unit.idloyer}>
                  <td>{unit.codeloyer}</td>
                  <td>{unit.netage}</td>

                  <td>{unit.location ? unit.location.nmlocataire : "-"}</td>

                  <td>{unit.location ? unit.location.phonelocataire : "-"}</td>

                  <td>
                    {formatFCFA(
                      unit.location ? unit.location.mtmensuel : unit.prixloyer,
                    )}
                  </td>

                  <td>
                    {unit.occupe ? (
                      <Stamp label="OCCUPÉ" tone="paid" />
                    ) : (
                      <Stamp label="LIBRE" tone="neutral" />
                    )}
                  </td>
                  <td className="rl-row-actions">
                    <button
                      className="rl-icon-btn"
                      onClick={() => onEdit(unit)}
                      title="Modifier"
                    >
                      <Pencil size={15} />
                    </button>
                    <button
                      className="rl-icon-btn rl-icon-btn-danger"
                      onClick={() => onDelete(unit)}
                      title="Liberer"
                    >
                      <DoorOpen size={15} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
// Gestion des paiements des locataires

const PAYMENT_METHODS = [
  { value: "ESPECES", label: "Espèces" },
  { value: "VIREMENT", label: "Virement bancaire" },
  { value: "ORANGE_MONEY", label: "Orange Money" },
  { value: "MOBILE_MONEY", label: "MTN Mobile Money" },
  { value: "CHEQUE", label: "Chèque" },
];

const MAX_JUSTIFICATIF_SIZE = 5 * 1024 * 1024; // 5 Mo

// ==============================
// MODAL DE PAIEMENT
// ==============================
// Deux modes selon le statut courant :
//  - "pay"    : le loyer n'est pas (ou pas totalement) payé -> formulaire complet
//  - "cancel" : le loyer est marqué payé -> simple confirmation d'annulation
function PaymentModal({
  unit,
  payment,
  periodLabel,
  onClose,
  onSave,
  onCancelPayment,
}) {
  const mode = payment?.statut === "PAYE" ? "cancel" : "pay";

  const rent = Number(
    payment?.rent ??
      unit.location?.mtmensuel ??
      unit.mtmensuel ??
      unit.rent ??
      unit.prixloyer ??
      0,
  );
  const dejaPaye = Number(payment?.montantPaye || 0);
  const reste = Number(payment?.reste ?? Math.max(rent - dejaPaye, 0));

  const [amount, setAmount] = useState(reste > 0 ? reste : rent);
  const [receiptNumber, setReceiptNumber] = useState("");
  const [paymentMethod, setPaymentMethod] = useState(PAYMENT_METHODS[0].value);
  const [paymentDate, setPaymentDate] = useState(todayISO());
  const [note, setNote] = useState("");
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const tenantName =
    payment?.tenantName ||
    unit.location?.nmlocataire ||
    unit.nmlocataire ||
    unit.tenantName ||
    "—";
  const codeLoyer = payment?.number || unit.codeloyer || unit.number || "—";

  function handleFileChange(e) {
    const f = e.target.files?.[0] || null;
    setFileError("");
    if (f && f.size > MAX_JUSTIFICATIF_SIZE) {
      setFileError("Le fichier dépasse 5 Mo.");
      setFile(null);
      e.target.value = "";
      return;
    }
    setFile(f);
  }

  async function handleSubmitPayment(e) {
    e.preventDefault();
    setError("");

    const montant = Number(amount);
    if (!montant || montant <= 0) {
      setError("Le montant payé doit être supérieur à 0.");
      return;
    }
    /*   if (reste > 0 && montant > reste) {
      setError(
        `Le montant saisi (${formatFCFA(montant)}) dépasse le reste à payer (${formatFCFA(reste)}).`,
      );
      return;
    }
    if (!receiptNumber.trim()) {
      setError("Le numéro de reçu est obligatoire.");
      return;
    }
      if (paymentDate > todayISO()) {
      setError("La date de paiement ne peut pas être dans le futur.");
      return;
    } 
    */
    if (!paymentDate) {
      setError("La date de paiement est obligatoire.");
      return;
    }

    setSaving(true);
    try {
      await onSave({
        amount: montant,
        receiptNumber: receiptNumber.trim(),
        paymentMethod,
        paymentDate,
        note: note.trim(),
        file,
      });
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          "Erreur lors de l'enregistrement du paiement. Veuillez réessayer.",
      );
      setSaving(false);
    }
  }

  async function handleConfirmCancel() {
    setError("");
    setSaving(true);
    try {
      await onCancelPayment();
    } catch (err) {
      setError(
        err?.response?.data?.error ||
          "Erreur lors de l'annulation du paiement. Veuillez réessayer.",
      );
      setSaving(false);
    }
  }

  return (
    <div className="rl-modal-backdrop" onClick={saving ? undefined : onClose}>
      <div
        className={`rl-modal ${mode === "cancel" ? "rl-modal-small" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="rl-modal-title">
          {mode === "cancel"
            ? "Annuler le paiement"
            : "Enregistrement du paiement"}
        </h3>

        <p className="rl-confirm-text" style={{ marginBottom: 4 }}>
          <strong>{codeLoyer}</strong> — {tenantName}
          {periodLabel ? ` · ${periodLabel}` : ""}
        </p>

        {mode === "cancel" ? (
          <>
            <p className="rl-confirm-text">
              Le loyer de <strong>{tenantName}</strong> pour cette période est
              actuellement marqué comme <strong>payé</strong>
              {payment?.paidDate ? ` (le ${payment.paidDate})` : ""}.
              Voulez-vous vraiment annuler ce paiement ? Le lot repassera en
              attente de règlement.
            </p>

            {error && (
              <div className="rl-error">
                <AlertTriangle size={14} />
                <span>{error}</span>
              </div>
            )}

            <div className="rl-modal-actions">
              <button
                type="button"
                className="rl-btn rl-btn-ghost"
                onClick={onClose}
                disabled={saving}
              >
                Retour
              </button>
              <button
                type="button"
                className="rl-btn rl-btn-danger"
                onClick={handleConfirmCancel}
                disabled={saving}
              >
                {saving ? (
                  <Loader2 className="rl-spin" size={14} />
                ) : (
                  <X size={14} />
                )}
                Annuler le paiement
              </button>
            </div>
          </>
        ) : (
          <form
            onSubmit={handleSubmitPayment}
            style={{ display: "flex", flexDirection: "column", gap: 12 }}
          >
            <div className="rl-field-row">
              <div
                className="rl-card"
                style={{ flex: 1, padding: "10px 12px" }}
              >
                <span className="rl-card-label">Loyer mensuel</span>
                <span className="rl-card-value" style={{ fontSize: "0.95rem" }}>
                  {formatFCFA(rent)}
                </span>
              </div>
              <div
                className="rl-card"
                style={{ flex: 1, padding: "10px 12px" }}
              >
                <span className="rl-card-label">Reste à payer</span>
                <span className="rl-card-value" style={{ fontSize: "0.95rem" }}>
                  {formatFCFA(reste > 0 ? reste : rent)}
                </span>
              </div>
            </div>

            <div className="rl-field-row">
              <label className="rl-field">
                <span>Montant payé ({formatFCFA(amount)}) *</span>
                <input
                  type="number"
                  min="1"
                  step="1"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  disabled={saving}
                  required
                />
              </label>
              <label className="rl-field">
                <span>Date de paiement *</span>
                <input
                  type="date"
                  value={paymentDate}
                  max={todayISO()}
                  onChange={(e) => setPaymentDate(e.target.value)}
                  disabled={saving}
                  required
                />
              </label>
            </div>

            <div className="rl-field-row">
              <label className="rl-field">
                <span>Numéro de reçu *</span>
                <input
                  type="text"
                  value={receiptNumber}
                  onChange={(e) => setReceiptNumber(e.target.value)}
                  placeholder=""
                  disabled={saving}
                  required
                />
              </label>
              <label className="rl-field">
                <span>Mode de paiement</span>
                <select
                  className="rl-select"
                  value={paymentMethod}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                  disabled={saving}
                >
                  {PAYMENT_METHODS.map((m) => (
                    <option key={m.value} value={m.value}>
                      {m.label}
                    </option>
                  ))}
                </select>
              </label>
            </div>

            <label className="rl-field">
              <span>Justificatif (image, facultatif — 5 Mo max)</span>
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                disabled={saving}
              />
              {file && (
                <span className="rl-muted" style={{ fontSize: "0.76rem" }}>
                  <ImagePlus size={12} style={{ verticalAlign: "-2px" }} />{" "}
                  {file.name}
                </span>
              )}
              {fileError && (
                <span
                  className="rl-muted"
                  style={{ fontSize: "0.76rem", color: "var(--rl-stamp-red)" }}
                >
                  {fileError}
                </span>
              )}
            </label>

            {error && (
              <div className="rl-error">
                <AlertTriangle size={14} />
                <span>{error}</span>
              </div>
            )}

            <div className="rl-modal-actions">
              <button
                type="button"
                className="rl-btn rl-btn-ghost"
                onClick={onClose}
                disabled={saving}
              >
                Fermer
              </button>
              <button
                type="submit"
                className="rl-btn rl-btn-primary"
                disabled={saving}
              >
                {saving ? (
                  <Loader2 className="rl-spin" size={14} />
                ) : (
                  <Check size={14} />
                )}
                {saving ? "Enregistrement..." : "Valider le paiement"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

// ==============================
// VUE PRINCIPALE
// ==============================
function PaymentsView({
  units,
  payments,
  period,
  onChangePeriod,
  onSavePayment,
  onCancelPayment,
  loadingPayments,
}) {
  const key = monthKey(period.year, period.month);
  const periodLabel = `${MONTHS_FR[period.month]} ${period.year}`;

  const activeUnits = units.filter(
    (u) => u.occupe === true || u.active === true,
  );

  const [selectedPayment, setSelectedPayment] = useState(null);

  return (
    <div className="rl-panel">
      {/* EN-TÊTE */}
      <div className="rl-panel-header">
        <h3 className="rl-panel-title">
          Situation des paiements des locations
        </h3>

        <div className="rl-period-switch">
          <button
            type="button"
            className="rl-icon-btn"
            onClick={() => onChangePeriod(-1)}
            disabled={loadingPayments}
            title="Mois précédent"
          >
            <ChevronLeft size={16} />
          </button>

          <span className="rl-period-label">
            {MONTHS_FR[period.month]} {period.year}
          </span>

          <button
            type="button"
            className="rl-icon-btn"
            onClick={() => onChangePeriod(1)}
            disabled={loadingPayments}
            title="Mois suivant"
          >
            <ChevronRight size={16} />
          </button>
        </div>
      </div>

      {/* CHARGEMENT */}
      {loadingPayments ? (
        <div className="rl-empty">
          <Loader2 className="rl-spin" size={20} />
          <span>Chargement des paiements...</span>
        </div>
      ) : activeUnits.length === 0 ? (
        <EmptyNote>Aucun lot occupé pour le moment.</EmptyNote>
      ) : (
        <div className="rl-payment-list">
          {activeUnits.map((u) => {
            const idlocation = u.idlocation || u.location?.idlocation || u.id;
            const p = payments[idlocation]?.[key];

            const paid = p?.statut === "PAYE";
            const partial = p?.statut === "PARTIEL";
            const late = p?.statut === "EN_RETARD";

            const rent = Number(
              p?.rent ??
                u.location?.mtmensuel ??
                u.mtmensuel ??
                u.rent ??
                u.prixloyer ??
                0,
            );

            const montantPaye = Number(p?.montantPaye || 0);
            // "reste" reflète le cumul renvoyé par le backend (mois du
            // tableau + arriérés éventuels des mois précédents non soldés).
            // Il se recalcule automatiquement à chaque changement de mois
            // puisque chargerPaiements() est relancé sur period.month/year.
            const reste = Number(p?.reste ?? Math.max(rent - montantPaye, 0));
            const arrieres = Number(p?.arrieres || 0);
            const moisEnRetard = Number(p?.moisEnRetard || 0);

            const tenantName =
              p?.tenantName ||
              u.location?.nmlocataire ||
              u.nmlocataire ||
              u.tenantName ||
              "—";

            const codeLoyer = p?.number || u.codeloyer || u.number || "—";

            return (
              <div className="rl-payment-row" key={idlocation}>
                {/* INFO LOCATION */}
                <div className="rl-payment-info">
                  <span className="rl-payment-unit">{codeLoyer}</span>
                  <div>
                    <strong>{tenantName}</strong>
                    <div className="rl-muted rl-mono rl-payment-amount">
                      {formatFCFA(rent)}
                    </div>
                  </div>
                </div>

                {/* ÉTAT DU PAIEMENT */}
                <div className="rl-payment-status">
                  {paid ? (
                    <>
                      <Stamp label="PAYÉ" tone="paid" />
                      {p?.paidDate && (
                        <span className="rl-paid-date">le {p.paidDate}</span>
                      )}
                      {p?.numeroRecu && (
                        <span className="rl-paid-date">
                          <Receipt size={13} /> {p.numeroRecu}
                        </span>
                      )}
                    </>
                  ) : partial ? (
                    <>
                      <Stamp label="PARTIEL" tone="late" />
                      <span className="rl-paid-date">
                        Payé : {formatFCFA(montantPaye)}
                      </span>
                      <span className="rl-paid-date">
                        Reste : {formatFCFA(reste)}
                      </span>
                      {arrieres > 0 && (
                        <span
                          className="rl-paid-date"
                          style={{ color: "var(--rl-stamp-red)" }}
                        >
                          dont {formatFCFA(arrieres)} de mois antérieurs
                        </span>
                      )}
                    </>
                  ) : late ? (
                    <>
                      <Stamp label="EN RETARD" tone="late" />
                      <span className="rl-paid-date">
                        Reste : {formatFCFA(reste)}
                      </span>
                      <span
                        className="rl-paid-date"
                        style={{ color: "var(--rl-stamp-red)" }}
                      >
                        {moisEnRetard} mois en retard
                        {arrieres > 0
                          ? ` (${formatFCFA(arrieres)} d'arriérés)`
                          : ""}
                      </span>
                    </>
                  ) : (
                    <>
                      <Stamp label="EN ATTENTE" tone="neutral" />
                      <span className="rl-paid-date">
                        Reste : {formatFCFA(reste)}
                      </span>
                    </>
                  )}
                </div>

                {/* ACTION */}
                <button
                  type="button"
                  className={`rl-btn rl-btn-sm ${
                    paid ? "rl-btn-ghost" : "rl-btn-primary"
                  }`}
                  onClick={() => setSelectedPayment({ unit: u, payment: p })}
                >
                  {paid ? (
                    <></>
                  ) : (
                    <>
                      <Check size={14} />
                      Effectuer paiement
                    </>
                  )}
                </button>
              </div>
            );
          })}
        </div>
      )}

      {/* MODAL */}
      {selectedPayment && (
        <PaymentModal
          unit={selectedPayment.unit}
          payment={selectedPayment.payment}
          periodLabel={periodLabel}
          onClose={() => setSelectedPayment(null)}
          onSave={async (data) => {
            const idlocation =
              selectedPayment.unit.idlocation ||
              selectedPayment.unit.location?.idlocation ||
              selectedPayment.unit.id;
            await onSavePayment(idlocation, key, data);
            setSelectedPayment(null);
          }}
          onCancelPayment={async () => {
            const idlocation =
              selectedPayment.unit.idlocation ||
              selectedPayment.unit.location?.idlocation ||
              selectedPayment.unit.id;
            await onCancelPayment(idlocation, key);
            setSelectedPayment(null);
          }}
        />
      )}
    </div>
  );
}

// Fenêtre de consultation de l'état des paiements des locataires,
// filtrable soit sur une date précise, soit sur une période (du / au).
// S'appuie sur l'endpoint déjà existant /etat_paiements_locations/
// (mois + année), interrogé pour chaque mois couvert par la sélection,
// puis on filtre les paiements réellement effectués (paidDate) dans
// l'intervalle demandé — pas d'endpoint supplémentaire nécessaire côté
// backend.
function monthsBetween(start, end) {
  const months = [];
  const cursor = new Date(start.getFullYear(), start.getMonth(), 1);
  const last = new Date(end.getFullYear(), end.getMonth(), 1);
  while (cursor <= last) {
    months.push({ annee: cursor.getFullYear(), mois: cursor.getMonth() + 1 });
    cursor.setMonth(cursor.getMonth() + 1);
  }
  return months;
}

function EtatPaiementView() {
  const todayStr = todayISO();
  const firstOfMonthStr = todayStr.slice(0, 8) + "01";

  const [mode, setMode] = useState("periode"); // "periode" | "date"
  const [dateDebut, setDateDebut] = useState(firstOfMonthStr);
  const [dateFin, setDateFin] = useState(todayStr);
  const [dateUnique, setDateUnique] = useState(todayStr);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [hasSearched, setHasSearched] = useState(false);

  async function fetchEtat() {
    const start = mode === "date" ? dateUnique : dateDebut;
    const end = mode === "date" ? dateUnique : dateFin;

    if (!start || !end) {
      setError("Merci de renseigner une date valide.");
      return;
    }
    if (new Date(start) > new Date(end)) {
      setError("La date de début doit précéder la date de fin.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const pairs = monthsBetween(new Date(start), new Date(end));

      const responses = await Promise.all(
        pairs.map((p) =>
          axios
            .get(`${API_URL}/etat_paiements_locations/`, { params: p })
            .then((res) => res.data?.locations || [])
            .catch((err) => {
              console.error(
                "Erreur chargement état paiements (période) :",
                err.response?.data || err,
              );
              return [];
            }),
        ),
      );

      const merged = responses.flat();

      // On ne garde que les paiements réellement enregistrés (montant > 0
      // ou marqués payés) dont la date de paiement tombe dans l'intervalle
      // choisi par l'utilisateur.
      const filtered = merged.filter((item) => {
        const hasPayment = item.paid === true || Number(item.montantPaye) > 0;
        if (!hasPayment || !item.paidDate) return false;
        const d = item.paidDate.slice(0, 10);
        return d >= start && d <= end;
      });

      filtered.sort((a, b) => (a.paidDate < b.paidDate ? 1 : -1));

      setRows(filtered);
    } catch (err) {
      console.error("Erreur chargement état des paiements :", err);
      setError(
        "Impossible de charger l'état des paiements pour cette sélection.",
      );
      setRows([]);
    } finally {
      setLoading(false);
      setHasSearched(true);
    }
  }

  useEffect(() => {
    fetchEtat();
    // Chargement initial avec la période par défaut (mois en cours).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filteredRows = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter((r) => {
      const haystack = [r.tenantName, r.phone, r.number, r.numeroRecu]
        .join(" ")
        .toLowerCase();
      return haystack.includes(q);
    });
  }, [rows, search]);

  const totals = useMemo(
    () =>
      filteredRows.reduce(
        (acc, r) => {
          acc.montant += Number(r.montantPaye || 0);
          acc.count += 1;
          return acc;
        },
        { montant: 0, count: 0 },
      ),
    [filteredRows],
  );

  const paymentMethodLabel = (value) =>
    PAYMENT_METHODS.find((m) => m.value === value)?.label || value || "—";

  return (
    <div className="rl-panel">
      <div className="rl-panel-header">
        <h3 className="rl-panel-title">État des paiements des locataires</h3>
      </div>

      <div className="rl-etat-view">
        <div className="rl-etat-filters">
          <div className="rl-etat-mode-toggle">
            <button
              type="button"
              className={`rl-btn rl-btn-sm ${
                mode === "periode" ? "rl-btn-primary" : "rl-btn-ghost"
              }`}
              onClick={() => setMode("periode")}
            >
              Par période
            </button>
            <button
              type="button"
              className={`rl-btn rl-btn-sm ${
                mode === "date" ? "rl-btn-primary" : "rl-btn-ghost"
              }`}
              onClick={() => setMode("date")}
            >
              Par date précise
            </button>
          </div>

          <div className="rl-field-row rl-etat-dates">
            {mode === "periode" ? (
              <>
                <label className="rl-field">
                  <span>Du</span>
                  <input
                    type="date"
                    className="rl-input"
                    value={dateDebut}
                    max={dateFin}
                    onChange={(e) => setDateDebut(e.target.value)}
                  />
                </label>
                <label className="rl-field">
                  <span>Au</span>
                  <input
                    type="date"
                    className="rl-input"
                    value={dateFin}
                    min={dateDebut}
                    onChange={(e) => setDateFin(e.target.value)}
                  />
                </label>
              </>
            ) : (
              <label className="rl-field">
                <span>Date</span>
                <input
                  type="date"
                  className="rl-input"
                  value={dateUnique}
                  onChange={(e) => setDateUnique(e.target.value)}
                />
              </label>
            )}

            <button
              type="button"
              className="rl-btn rl-btn-primary rl-btn-sm rl-etat-search-btn"
              onClick={fetchEtat}
              disabled={loading}
            >
              {loading ? (
                <Loader2 size={14} className="rl-spin" />
              ) : (
                <Search size={14} />
              )}
              Rechercher
            </button>
          </div>

          <div className="rl-search-bar" style={{ position: "relative" }}>
            <Search
              size={14}
              style={{
                position: "absolute",
                left: 10,
                top: "50%",
                transform: "translateY(-50%)",
                opacity: 0.5,
              }}
            />
            <input
              type="text"
              className="rl-input"
              placeholder="Filtrer par locataire, lot, téléphone ou n° reçu..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: "100%",
                padding: "8px 10px 8px 32px",
                boxSizing: "border-box",
              }}
            />
          </div>
        </div>

        <div className="rl-etat-results">
          {error && (
            <div className="rl-error">
              <AlertTriangle size={14} />
              {error}
            </div>
          )}

          {loading ? (
            <div className="rl-etat-loading">
              <Loader2 className="rl-spin" size={18} />
              <span>Chargement des paiements…</span>
            </div>
          ) : !error && hasSearched && filteredRows.length === 0 ? (
            <EmptyNote>
              Aucun paiement trouvé pour cette{" "}
              {mode === "date" ? "date" : "période"}.
            </EmptyNote>
          ) : !error && filteredRows.length > 0 ? (
            <>
              <div className="rl-etat-summary">
                <span>
                  <strong>{totals.count}</strong> paiement
                  {totals.count > 1 ? "s" : ""}
                </span>
                <span>
                  Total encaissé : <strong>{formatFCFA(totals.montant)}</strong>
                </span>
              </div>

              <div className="rl-table-wrap">
                <table className="rl-table">
                  <thead>
                    <tr>
                      <th>Date paiement</th>
                      <th>Locataire</th>
                      <th>Lot</th>
                      <th>Téléphone</th>
                      <th>Montant payé</th>
                      <th>Mode</th>
                      <th>N° reçu</th>
                      <th>Statut</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredRows.map((r, idx) => (
                      <tr key={`${r.idlocation}-${r.mois}-${r.annee}-${idx}`}>
                        <td>{r.paidDate ? r.paidDate.slice(0, 10) : "—"}</td>
                        <td>{r.tenantName || "—"}</td>
                        <td>{r.number || "—"}</td>
                        <td>{r.phone || "—"}</td>
                        <td>{formatFCFA(r.montantPaye)}</td>
                        <td>
                          {paymentMethodLabel(
                            r.moyenPaiement ||
                              r.modePaiement ||
                              r.paymentMethod,
                          )}
                        </td>
                        <td>{r.numeroRecu || "—"}</td>
                        <td>
                          {r.statut === "PAYE" || r.paid ? (
                            <Stamp label="PAYÉ" tone="paid" />
                          ) : (
                            <Stamp label="PARTIEL" tone="neutral" />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("dashboard");
  const [period, setPeriod] = useState(() => {
    const d = new Date();
    return { year: d.getFullYear(), month: d.getMonth() };
  });
  const [editingUnit, setEditingUnit] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  // État des paiements chargé depuis l'API, tenu à jour à chaque
  // changement de mois/année (period.month / period.year).
  const [paymentsAPI, setPaymentsAPI] = useState({});
  const [loadingPayments, setLoadingPayments] = useState(false);

  const chargerPaiements = useCallback(async () => {
    try {
      setLoadingPayments(true);

      /*
       * period.month commence à 0 en JavaScript :
       *
       * Janvier = 0
       * Février = 1
       * ...
       * Décembre = 11
       *
       * Dans MySQL :
       *
       * Janvier = 1
       * Février = 2
       * ...
       * Décembre = 12
       */
      const mois = period.month + 1;
      const annee = period.year;

      const response = await axios.get(`${API_URL}/etat_paiements_locations/`, {
        params: { mois, annee },
      });

      const locations = response.data?.locations || [];

      const formatted = {};

      locations.forEach((item) => {
        /*
         * IMPORTANT :
         * monthKey attend un index JavaScript, donc il faut faire mois - 1.
         * Exemple : mois DB = 8 -> index JS = 7 -> "2026-08"
         */
        const key = monthKey(item.annee, item.mois - 1);
        const idlocation = item.idlocation;

        if (!formatted[idlocation]) {
          formatted[idlocation] = {};
        }

        formatted[idlocation][key] = {
          idlocation: item.idlocation,
          idloyer: item.idloyer,
          number: item.number,
          description: item.description,
          tenantName: item.tenantName,
          phone: item.phone,
          rent: Number(item.rent || 0),
          paid: item.paid === true,
          statut: item.statut,
          montantPaye: Number(item.montantPaye || 0),
          // "reste" est déjà le cumul renvoyé par le backend : il inclut
          // les mois antérieurs non soldés, pas seulement le mois affiché.
          reste: Number(item.reste || 0),
          arrieres: Number(item.arrieres || 0),
          totalDu: Number(item.totalDu ?? item.rent ?? 0),
          moisEnRetard: Number(item.moisEnRetard || 0),
          paidDate: item.paidDate || null,
          numeroRecu: item.numeroRecu || null,
          motifPaiement: item.motifPaiement || null,
          mois: item.mois,
          annee: item.annee,
        };
      });

      setPaymentsAPI(formatted);
    } catch (error) {
      console.error(
        "Erreur chargement état paiements :",
        error.response?.data || error,
      );
      setPaymentsAPI({});
    } finally {
      setLoadingPayments(false);
    }
  }, [period.month, period.year]);

  // Recharge la situation des paiements à CHAQUE changement de mois/année,
  // quel que soit l'onglet actif (Tableau de bord ou Paiements).
  useEffect(() => {
    chargerPaiements();
  }, [chargerPaiements]);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const res = await window.storage.get(STORAGE_KEY);
        if (!cancelled) setData(JSON.parse(res.value));
      } catch (e) {
        const seeded = seedData();
        if (!cancelled) setData(seeded);
        try {
          await window.storage.set(STORAGE_KEY, JSON.stringify(seeded));
        } catch (_) {}
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);
  const chargerAppartements = () => {
    axios
      .get(`${API_URL}/appartlist/`)
      .then((res) => {
        setdata1(res.data);
      })
      .catch((err) => console.error(err));
  };

  // Chargement des appartements/loyers depuis la base de données dès
  // l'ouverture de la fenêtre (montage du composant), et non plus
  // seulement lorsqu'on clique sur l'onglet "Plan occupation".
  useEffect(() => {
    chargerAppartements();
  }, []);

  function persist(next) {
    setData(next);
    window.storage.set(STORAGE_KEY, JSON.stringify(next)).catch(() => {});
  }

  function changePeriod(delta) {
    setPeriod((p) => {
      const d = new Date(p.year, p.month + delta, 1);
      return { year: d.getFullYear(), month: d.getMonth() };
    });
  }

  function handleAddUnit() {
    setEditingUnit(null);
    setShowForm(true);
  }
  function handleEditUnit(u) {
    setEditingUnit(u);
    setShowForm(true);
  }

  function handleSaveUnit(form) {
    if (editingUnit) {
      const nextUnits = data.units.map((u) =>
        u.id === editingUnit.id ? { ...u, ...form } : u,
      );
      persist({ ...data, units: nextUnits });
    } else {
      const newUnit = { id: uid(), ...form };
      persist({ ...data, units: [...data.units, newUnit] });
    }
    setShowForm(false);
    setEditingUnit(null);
  }

  async function handleDeleteConfirmed(idloyer) {
    console.log("ID LOYER ENVOYE :", idloyer);
    try {
      const response = await axios.post(`${API_URL}/update_location/`, {
        idloyer: idloyer,
      });

      setDeleteTarget(null);

      // Si vous rechargez la liste des logements
      chargerAppartements(); // ou fetchData(), getLoyers(), etc.
      console.log("Réponse serveur :", response.data);
    } catch (error) {
      console.log("Erreur Axios :", error);
      console.log("Statut :", error.response?.status);
      console.log("Réponse Django :", error.response?.data);
    }
  }

  // Enregistre un paiement (total ou partiel) pour une location, sur la
  // période "YYYY-MM" indiquée par key. Envoie réellement au serveur les
  // informations saisies dans le modal (montant, reçu, moyen de paiement,
  // date, remarque, justificatif éventuel) — c'est ce qui manquait
  // auparavant : le modal collectait ces données mais elles n'étaient
  // jamais transmises à l'API.
  async function savePaiement(idlocation, key, paymentData) {
    const [annee, mois] = key.split("-").map(Number);
    const { amount, receiptNumber, paymentMethod, paymentDate, note, file } =
      paymentData;

    try {
      let response;

      if (file) {
        // Un justificatif est joint : on envoie en multipart/form-data.
        const formData = new FormData();
        formData.append("annee", annee);
        formData.append("mois", mois);
        formData.append("montant", amount);
        formData.append("numeroRecu", receiptNumber);
        formData.append("moyenPaiement", paymentMethod);
        formData.append("datePaiement", paymentDate);
        //  if (note) formData.append("motifPaiement", note);
        formData.append("justificatif", file);

        response = await axios.post(
          `${API_URL}/enregistrer_paiement_location/${idlocation}/`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } },
        );
      } else {
        response = await axios.post(
          `${API_URL}/enregistrer_paiement_location/${idlocation}/`,
          {
            annee,
            mois,
            montant: amount,
            numeroRecu: receiptNumber,
            moyenPaiement: paymentMethod,
            datePaiement: paymentDate,
            motifPaiement: note || null,
          },
        );
      }

      // Recharger la situation des paiements depuis le serveur pour que
      // l'affichage (statut PAYE/PARTIEL, reste, date, n° de reçu) reflète
      // immédiatement l'enregistrement.
      await chargerPaiements();
      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors de l'enregistrement du paiement :",
        error.response?.data || error,
      );
      throw error;
    }
  }

  // Annule un paiement précédemment marqué "payé" pour une location, sur
  // la période "YYYY-MM" indiquée par key. Le lot repasse en attente.
  async function annulerPaiement(idlocation, key) {
    const [annee, mois] = key.split("-").map(Number);

    try {
      await axios.post(`${API_URL}/toggle_paiement_location/${idlocation}/`, {
        annee,
        mois,
        paid: false,
      });

      await chargerPaiements();
    } catch (error) {
      console.error(
        "Erreur lors de l'annulation du paiement :",
        error.response?.data || error,
      );
      throw error;
    }
  }
  const [data1, setdata1] = useState([]);

  function resetData() {
    const seeded = seedData();
    persist(seeded);
  }

  if (loading) {
    return (
      <div className="rl-root rl-loading">
        <style>{CSS}</style>
        <Loader2 className="rl-spin" size={22} />
        <span>Ouverture du registre…</span>
      </div>
    );
  }

  const tabs = [
    { id: "dashboard", label: "Tableau de bord", icon: LayoutDashboard },
    { id: "apartments", label: "Plan occupation", icon: Home },
    { id: "payments", label: "Paiements", icon: Receipt },
    { id: "paymentsetat", label: "Etat Paiements", icon: Receipt },
  ];

  return (
    <div className="rl-root">
      <style>{CSS}</style>

      <aside className="rl-sidebar">
        <div className="rl-brand">
          <Building2 size={20} />
          <div>
            <div className="rl-brand-name">{data.building.name}</div>
            <div className="rl-brand-address">{data.building.address}</div>
          </div>
        </div>
        <nav className="rl-nav">
          {tabs.map((t) => {
            const Icon = t.icon;
            return (
              <button
                key={t.id}
                className={`rl-nav-item ${tab === t.id ? "rl-nav-item-active" : ""}`}
                onClick={() => setTab(t.id)}
              >
                <Icon size={16} /> {t.label}
              </button>
            );
          })}
        </nav>
        <button className="rl-reset-link" onClick={resetData}>
          <RotateCcw size={13} /> Réinitialiser les données
        </button>
      </aside>

      <main className="rl-main">
        <div className="rl-main-inner">
          {tab === "dashboard" && (
            <Dashboard
              units={data1.length ? data1 : data.units}
              payments={paymentsAPI}
              period={period}
              onChangePeriod={changePeriod}
              loadingPayments={loadingPayments}
            />
          )}
          {tab === "apartments" && (
            <ApartmentsView
              units={data1}
              onAdd={handleAddUnit}
              onEdit={handleEditUnit}
              onDelete={(u) => setDeleteTarget(u)}
            />
          )}
          {tab === "payments" && (
            <PaymentsView
              units={data1.length ? data1 : data.units}
              payments={paymentsAPI}
              period={period}
              onChangePeriod={changePeriod}
              onSavePayment={savePaiement}
              onCancelPayment={annulerPaiement}
              loadingPayments={loadingPayments}
            />
          )}
          {tab === "paymentsetat" && <EtatPaiementView />}
        </div>
      </main>

      {showForm && (
        <UnitForm
          initial={editingUnit}
          onCancel={() => {
            setShowForm(false);
            setEditingUnit(null);
          }}
          chargerAppartements={chargerAppartements}
        />
      )}

      {deleteTarget && (
        <ConfirmDialog
          idloyer={deleteTarget.idloyer}
          text={`Libérer ${deleteTarget.codeloyer} ?`}
          onCancel={() => setDeleteTarget(null)}
          onConfirm={handleDeleteConfirmed}
        />
      )}
    </div>
  );
}

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Lora:wght@500;600;700&family=IBM+Plex+Mono:wght@400;500;600&family=Inter:wght@400;500;600&display=swap');


.rl-select {
  width: 100%;
  height: 42px;
  padding: 0 14px;
  border: 1px solid var(--rl-line);
  border-radius: 8px;
  background: #fff;
  color: var(--rl-ink);
  font-size: 0.9rem;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.25s ease;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  /* Flèche personnalisée */
  background-image:
    linear-gradient(45deg, transparent 50%, #64705F 50%),
    linear-gradient(135deg, #64705F 50%, transparent 50%);
  background-position:
    calc(100% - 18px) calc(50% - 3px),
    calc(100% - 12px) calc(50% - 3px);
  background-size: 6px 6px, 6px 6px;
  background-repeat: no-repeat;
}

.rl-select:hover {
  border-color: var(--rl-spine);
  background-color: #fafcf9;
}

.rl-select:focus {
  outline: none;
  border-color: var(--rl-accent-gold);
  box-shadow: 0 0 0 3px rgba(176, 141, 62, 0.18);
}

.rl-select option {
  padding: 10px;
  color: var(--rl-ink);
}
  
.rl-root {
  --rl-bg: #EDF1EA;
  --rl-paper: #FFFFFF;
  --rl-ink: #1F2B22;
  --rl-spine: #24402C;
  --rl-spine-light: #325940;
  --rl-accent-gold: #B08D3E;
  --rl-stamp-red: #A8332B;
  --rl-stamp-green: #2F6B3E;
  --rl-line: #DCE3D6;
  --rl-muted: #64705F;

  font-family: var(--rl-sans, 'Inter', sans-serif);
  color: var(--rl-ink);
  background: var(--rl-bg);
  display: flex;
  min-height: 560px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid var(--rl-line);
}

.rl-loading {
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 300px;
  color: var(--rl-muted);
}
.rl-spin { animation: rl-spin 1s linear infinite; }
@keyframes rl-spin { to { transform: rotate(360deg); } }

.rl-sidebar {
  width: 230px;
  flex-shrink: 0;
  background: linear-gradient(180deg, var(--rl-spine), var(--rl-spine-light));
  color: #EDF1EA;
  display: flex;
  flex-direction: column;
  padding: 20px 14px;
}
.rl-brand {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 4px 6px 20px 6px;
  border-bottom: 1px solid rgba(237,241,234,0.18);
  margin-bottom: 14px;
}
.rl-brand-name {
  font-family: 'Lora', serif;
  font-weight: 600;
  font-size: 0.95rem;
  line-height: 1.25;
}
.rl-brand-address {
  font-size: 0.72rem;
  opacity: 0.7;
  margin-top: 2px;
}
.rl-nav {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
}
.rl-nav-item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 9px 10px;
  border-radius: 6px;
  background: transparent;
  border: none;
  color: rgba(237,241,234,0.82);
  font-size: 0.84rem;
  text-align: left;
  cursor: pointer;
  border-left: 2px solid transparent;
}
.rl-nav-item:hover { background: rgba(237,241,234,0.08); }
.rl-nav-item-active {
  background: rgba(237,241,234,0.12);
  color: #fff;
  border-left: 2px solid var(--rl-accent-gold);
}
.rl-reset-link {
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: rgba(237,241,234,0.55);
  font-size: 0.72rem;
  cursor: pointer;
  padding: 8px 6px;
}
.rl-reset-link:hover { color: rgba(237,241,234,0.85); }

.rl-main {
  flex: 1;
  background-image: repeating-linear-gradient(
    to bottom,
    transparent,
    transparent 27px,
    var(--rl-line) 28px
  );
  overflow-y: auto;
  max-height: 720px;
}
.rl-main-inner { padding: 24px 26px 40px 26px; }

.rl-cards-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 18px;
}
.rl-card {
  background: var(--rl-paper);
  border: 1px solid var(--rl-line);
  border-radius: 8px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  box-shadow: 0 1px 2px rgba(31,43,34,0.04);
}
.rl-card-label {
  font-size: 0.72rem;
  color: var(--rl-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.rl-card-value {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1.15rem;
  font-weight: 600;
}
.rl-card-sub { font-size: 0.74rem; color: var(--rl-muted); }

.rl-panel {
  background: var(--rl-paper);
  border: 1px solid var(--rl-line);
  border-radius: 8px;
  padding: 18px 20px;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px rgba(31,43,34,0.04);
}
.rl-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.rl-panel-title {
  font-family: 'Lora', serif;
  font-weight: 600;
  font-size: 1rem;
  margin: 0 0 4px 0;
}
.rl-panel-header .rl-panel-title { margin-bottom: 0; }

.rl-empty {
  color: var(--rl-muted);
  font-size: 0.86rem;
  font-style: italic;
  padding: 8px 2px;
}

.rl-history {
  display: flex;
  gap: 14px;
  align-items: flex-end;
  height: 110px;
  padding-top: 10px;
}
.rl-history-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 1;
}
.rl-history-bar-track {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: flex-end;
  background: var(--rl-bg);
  border-radius: 4px;
  overflow: hidden;
}
.rl-history-bar {
  width: 100%;
  background: var(--rl-stamp-green);
  border-radius: 4px 4px 0 0;
  min-height: 2px;
}
.rl-history-rate {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 0.72rem;
  color: var(--rl-muted);
}
.rl-history-label { font-size: 0.72rem; color: var(--rl-muted); text-transform: capitalize; }

.rl-overdue-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 8px; }
.rl-overdue-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px 10px;
  background: var(--rl-bg);
  border-radius: 6px;
  font-size: 0.86rem;
}
.rl-overdue-right { display: flex; align-items: center; gap: 14px; font-family: 'IBM Plex Mono', monospace; font-size: 0.8rem; }

.rl-muted { color: var(--rl-muted); }
.rl-mono { font-family: 'IBM Plex Mono', monospace; }

.rl-phone-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--rl-spine);
  text-decoration: none;
  font-size: 0.8rem;
}
.rl-phone-link:hover { text-decoration: underline; }

.rl-table-wrap { overflow-x: auto; }
.rl-table { width: 100%; border-collapse: collapse; font-size: 0.86rem; }
.rl-table th {
  text-align: left;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--rl-muted);
  padding: 6px 10px;
  border-bottom: 1px solid var(--rl-line);
}
.rl-table td {
  padding: 10px;
  border-bottom: 1px solid var(--rl-line);
  vertical-align: middle;
}
.rl-row-actions { display: flex; gap: 4px; }

.rl-icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--rl-muted);
  padding: 5px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.rl-icon-btn:hover { background: var(--rl-bg); color: var(--rl-ink); }
.rl-icon-btn-danger:hover { color: var(--rl-stamp-red); }

.rl-btn {
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.84rem;
  padding: 8px 14px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: inherit;
}
.rl-btn-sm { padding: 6px 11px; font-size: 0.78rem; }
.rl-btn-primary { background: var(--rl-spine); color: #fff; }
.rl-btn-primary:hover { background: var(--rl-spine-light); }
.rl-btn-ghost { background: transparent; color: var(--rl-ink); border: 1px solid var(--rl-line); }
.rl-btn-ghost:hover { background: var(--rl-bg); }
.rl-btn-danger { background: var(--rl-stamp-red); color: #fff; }
.rl-btn-danger:hover { opacity: 0.9; }

.rl-stamp {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 11px;
  border: 2px solid currentColor;
  border-radius: 6px;
  position: relative;
  font-family: 'IBM Plex Mono', monospace;
  font-weight: 700;
  letter-spacing: 0.1em;
  font-size: 0.65rem;
  transform: rotate(-4deg);
  mix-blend-mode: multiply;
  opacity: 0.88;
  white-space: nowrap;
}

.rl-period-switch { display: flex; align-items: center; gap: 8px; }
.rl-period-label {
  font-family: 'Lora', serif;
  font-weight: 600;
  min-width: 130px;
  text-align: center;
  font-size: 0.9rem;
}

.rl-payment-list { display: flex; flex-direction: column; gap: 8px; }
.rl-payment-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 12px;
  background: var(--rl-bg);
  border-radius: 7px;
  flex-wrap: wrap;
}
.rl-payment-info { display: flex; align-items: center; gap: 12px; flex: 1; min-width: 180px; }
.rl-payment-unit {
  font-family: 'IBM Plex Mono', monospace;
  font-weight: 600;
  background: var(--rl-paper);
  border: 1px solid var(--rl-line);
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 0.8rem;
}
.rl-payment-amount { font-size: 0.78rem; margin-top: 2px; }
.rl-payment-status { display: flex; align-items: center; gap: 8px; }
.rl-paid-date { font-size: 0.72rem; color: var(--rl-muted); }

.rl-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(31,43,34,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  padding: 20px;
}
.rl-modal {
  background: var(--rl-paper);
  border-radius: 10px;
  padding: 22px 24px;
  width: 100%;
  max-width: 520px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}
.rl-modal-small { max-width: 360px; }
.rl-modal-large { max-width: 860px; }
.rl-modal-header-row { display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; }
.rl-modal-title { font-family: 'Lora', serif; font-size: 1.05rem; margin: 0 0 4px 0; }
.rl-input {
  border: 1px solid var(--rl-line);
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 0.86rem;
  font-family: inherit;
  background: #fff;
  color: var(--rl-ink);
}
.rl-input:focus {
  outline: 2px solid var(--rl-accent-gold);
  outline-offset: 1px;
}
.rl-etat-view { display: flex; flex-direction: column; gap: 14px; }
.rl-etat-filters { display: flex; flex-direction: column; gap: 10px; }
.rl-etat-mode-toggle { display: flex; gap: 8px; }
.rl-etat-dates { align-items: flex-end; flex-wrap: wrap; }
.rl-etat-search-btn { align-self: flex-end; }
.rl-etat-results { display: flex; flex-direction: column; gap: 10px; min-height: 80px; }
.rl-etat-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--rl-muted);
  font-size: 0.86rem;
  padding: 20px 0;
  justify-content: center;
}
.rl-etat-summary {
  display: flex;
  justify-content: space-between;
  font-size: 0.84rem;
  color: var(--rl-muted);
  background: var(--rl-bg);
  padding: 8px 12px;
  border-radius: 6px;
}
.rl-field { display: flex; flex-direction: column; gap: 4px; font-size: 0.82rem; flex: 1; }
.rl-field span { color: var(--rl-muted); font-size: 0.76rem; }
.rl-field input {
  border: 1px solid var(--rl-line);
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 0.86rem;
  font-family: inherit;
}
.rl-field input:focus, .rl-btn:focus-visible, .rl-icon-btn:focus-visible, .rl-nav-item:focus-visible {
  outline: 2px solid var(--rl-accent-gold);
  outline-offset: 1px;
}
.rl-field-row { display: flex; gap: 10px; }
.rl-checkbox-row { display: flex; align-items: center; gap: 8px; font-size: 0.84rem; }
.rl-error {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--rl-stamp-red);
  font-size: 0.78rem;
  background: #F7E9E7;
  padding: 7px 9px;
  border-radius: 6px;
}
.rl-confirm-text { font-size: 0.88rem; line-height: 1.4; margin: 0; }
.rl-modal-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 4px; }

@media (max-width: 720px) {
  .rl-root { flex-direction: column; }
  .rl-sidebar { width: 100%; flex-direction: row; align-items: center; padding: 12px; }
  .rl-brand { border-bottom: none; padding-bottom: 0; margin-bottom: 0; }
  .rl-nav { flex-direction: row; }
  .rl-reset-link { display: none; }
  .rl-cards-grid { grid-template-columns: 1fr 1fr; }
  .rl-field-row { flex-direction: column; }
}
`;
